import React from "react";
import { ClipboardListIcon, StethoscopeIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { Countdown } from "../Countdown";
import { ScarcityBar } from "../ScarcityBar";
import { images } from "../../data/landing";
export function Hero() {
  return <header className="bg-cream px-4 pb-14 pt-6 sm:pt-10" data-id="element-185" data-mp="huo1e2ebseqg">
      <div className="mx-auto max-w-5xl" data-id="element-186" data-mp="hw8wpu8gs1pd">
        <div className="flex flex-wrap items-center justify-center gap-2.5" data-id="element-187" data-mp="muaco6alfkwm">
          <div className="flex items-center gap-2" data-id="element-188" data-mp="ms7pdu0ts5vl">
            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-navy text-gold" data-id="element-189" data-mp="qukmju1iavgr">
              <StethoscopeIcon className="h-5 w-5" aria-hidden="true" data-id="element-190" data-mp="vnng426aa4wy" />
            </span>
            <span className="font-serif text-lg font-bold text-navy" data-id="element-191" data-mp="10kdw6pi390id">Lipo Planning Workbook™</span>
          </div>
          <span className="flex items-center gap-1.5 rounded-full border border-gold/50 bg-white px-3 py-1 text-xs font-bold uppercase tracking-wide text-navy" data-id="element-192" data-mp="15ltj6n3tth3e">
            <ClipboardListIcon className="h-3.5 w-3.5 text-gold-dark" aria-hidden="true" data-id="element-193" data-mp="9oc7ckrt1ph5" />
            For plastic surgeons & aesthetic physicians
          </span>
        </div>

        <h1 className="mx-auto mt-7 max-w-4xl text-center font-serif text-[2.35rem] font-extrabold leading-[1.08] text-navy sm:text-6xl" data-id="element-194" data-mp="3vv108lvug06j">
          Organize any liposuction case in{" "}
          <em className="italic text-gold-dark" data-id="element-195" data-mp="3rviclicn1b00">15 minutes</em>
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-center text-[17px] leading-relaxed text-navy/80 sm:text-xl" data-id="element-196" data-mp="sdsmad48lkh3">
          A structured professional planning workbook to organize your case review, identify the variables that deserve
          attention, clarify your priorities and document your preoperative thinking. Includes{" "}
          <strong className="text-navy" data-id="element-197" data-mp="el2v7u9uppd4">6 premium volumes</strong>, <strong className="text-navy" data-id="element-198" data-mp="1b5lcy0vu2tln">5 professional bonuses</strong> and{" "}
          <strong className="text-navy" data-id="element-199" data-mp="16dtivgdgy5qr">30+ planning tools</strong>.
        </p>

        <img src={images.mockup} alt="Lipo Planning Workbook complete system: 6 volumes, worksheets and 5 bonuses" className="mx-auto mt-6 w-full max-w-2xl" data-id="element-200" data-mp="30m78aav3j68q" />

        <div className="mt-6" data-id="element-201" data-mp="2qwdssyru26z7">
          <CtaButton id="first-cta" label="I want the Lipo Planning Workbook™" note="Instant digital access · One-time payment of $27 · Lifetime access · 7-day guarantee" data-id="element-202" data-mp="2qv2p0yye0z83" />
        </div>

        <div className="mt-8 flex flex-col items-center gap-5" data-id="element-203" data-mp="2hxiojs8cn6yj">
          <Countdown data-id="element-204" data-mp="2mvk9yjt8zid6" />
          <ScarcityBar data-id="element-205" data-mp="2mvtye2yn9hgr" />
          <p className="text-center text-sm text-navy/60" data-id="element-206" data-mp="2ms677ago9757">Currency conversion is handled automatically according to your country.</p>
        </div>
      </div>
    </header>;
}